import request from '@/utils/request'


// 查询用户佣金记录列表
export function listDistributorRecord(query) {
  return request({
    url: '/biz/admin/user/distributor/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户佣金记录分页
export function pageDistributorRecord(query) {
  return request({
    url: '/biz/admin/user/distributor/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户佣金记录详细
export function getDistributorRecord(data) {
  return request({
    url: '/biz/admin/user/distributor/record/detail',
    method: 'get',
    params: data
  })
}

// 新增用户佣金记录
export function addDistributorRecord(data) {
  return request({
    url: '/biz/admin/user/distributor/record/add',
    method: 'post',
    data: data
  })
}

// 修改用户佣金记录
export function updateDistributorRecord(data) {
  return request({
    url: '/biz/admin/user/distributor/record/edit',
    method: 'post',
    data: data
  })
}

// 删除用户佣金记录
export function delDistributorRecord(data) {
  return request({
    url: '/biz/admin/user/distributor/record/delete',
    method: 'post',
    data: data
  })
}
